const $window = $(window);
let windowWidth = $window.width();

// メディアクエリ
let mql = window.matchMedia('screen and (max-width: 1024px)');

// preload
import {preload} from "../include/module";
preload();

// resizing
import {resizing} from "../include/module";
resizing();

// ヘッダーの開閉
import {headerToggle} from "../include/module";
headerToggle();

// ページTOP
import {backToTop} from "../include/module";
backToTop();

// リンクのアニメーション
import {anchorScroll} from "../include/module";
anchorScroll();

// ヘッダーのスクロール
import {headerScroll} from "../include/module";
headerScroll();

// スクロールアニメーション
import {scrollAnimation} from "../include/module";
scrollAnimation();

$(window).on('load' , function() {

  setTimeout(function(){
    $('.sw-Loader').addClass("load")
  },200);

  setTimeout(function(){
    $('.sw-Loader').addClass("hidden")
  },650);

});

const loadingAnimation = () =>{
  let timer = 0;
  $(window).on('load' , function() {
    if (timer > 0) {
      clearTimeout(timer);
    }
    timer = setTimeout(function () {
      $('.js-loadAnimation').addClass('is-animated');
    }, 100);
  });
};
loadingAnimation();

// const cutText = () => {
//   $(window).on('load' , function() {
//     $('.ellipsis p').trunk8({
//       fill: '…',
//       lines: 2
//     });
//   });
//
//   let timer = 0;
//   $(window).on('resize' , function() {
//     if (timer > 0) {
//       clearTimeout(timer);
//     }
//     timer = setTimeout(function () {
//       $('.ellipsis p').trunk8({
//         fill: '…',
//         lines: 2
//       });
//     }, 100);
//   });
// };
// cutText();

// キャラスライダー
const characterSlider = () => {
  const el = document.querySelector('.index-Character .swiper-container');

  if(!el){
    return false;
  }

  const sliderLength = el.querySelectorAll('li').length;
  const nextEl = document.querySelector('.index-Character .swiper-button-next');
  const prevEl = document.querySelector('.index-Character .swiper-button-prev');
  const paginationEl = document.querySelector('.index-Character .swiper-pagination');
  const settings = {
    centeredSlides: false,
    speed: 800,
    // autoplay: {
    //   delay: 5000,
    //   disableOnInteraction: false,
    // },
    watchOverflow: true,
    slidesPerView: 1,
    direction: 'horizontal',
    loop: true,
    navigation: {
      nextEl: nextEl,
      prevEl: prevEl,
    },
    pagination: {
      el: paginationEl,
      type: 'bullets',
      clickable: true,
    },
    loopAdditionalSlides: sliderLength,
    breakpoints: {
      1024: {
        slidesPerView: 1,
        loopAdditionalSlides: 1,
        centeredSlides: true,
      }
    },
  }

  let swiper;
  let flg = false;
  el.classList.add('disabled');
  // swiper = new Swiper (el, settings);

  if(sliderLength <= 1){ //1or0
    if(typeof swiper === 'undefined'){}else{
      swiper.destroy(true,true);
      el.classList.add('disabled');
      flg = false;
    }
  }
  if(sliderLength >= 2){　//2以上
    if(!flg){
      el.classList.remove('disabled');
      swiper = new Swiper (el, settings);
      flg = true;
    }
  }
};
characterSlider();


// YouTubeのモーダル
import {youtubeModal} from "../include/module";
youtubeModal();



// WEBPACK FOOTER //
// ./src/vaas/assets/js/services/script.js